export default __webpack_public_path__ + "static/media/cage-circle.3f05415a.svg";